import styled from 'styled-components';

export default styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
  bottom: 8px;
  width: calc(100% - 16px);
  max-width: 600px;
  z-index: 90;
  padding: 16px;
  box-sizing: border-box;

  border-radius: 4px;
  background: rgba(0, 0, 0, 0.90);

  @media (max-width: 768px) {
    max-width: calc(100% - 16px);
  }

  button {
    border-radius: 4px;
    border: 1px solid #1F1F1F;
    background: #1F1F1F;
    padding: 8px 12px;
    margin: 0;
    transition: background-color ease-in-out .2s;
    color: #FFFFFF;
    cursor: pointer;

    &:hover {
      background: #262626;
    }

    &:disabled {
      background: #141414;
      color: #424242;
      cursor: not-allowed;
      pointer-events: none;
    }
  }

  .mindmap__btn--close {
    height: 40px;
    width: 40px;
  }

  .mindmap__backdrop {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: -1;
  }

  .mindmap__container {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
  }

  .mindmap__content {
    color: var(--gray-05, #D9D9D9);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: -0.28px;
    height: calc(100% - 88px);
    overflow: auto;
    white-space: pre-line;
    scrollbar-width: thin;
  }

  .mindmap__heading {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;

    h1 {
      width: 100%;
      text-align: left;
    }

    button {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    svg {
      width: 12px;
      height: 12px;
    }
  }

  .mindmap__footer {
    gap: 8px;
    display: flex;
    flex-flow: row nowrap;
    width: 100%;

    & > button {
      width: 50%;
    }
  }

  .mindmap__title {
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: -0.28px;
    margin: 10px 0;
  }

  .mindmap_hr {
    border: 0;
    background: #1F1F1F;
    display: flex;
    height: 1px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    margin: 0;
  }
`;
